import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { tours } from '../data/tours';
import { Button } from '../components/ui/Button';
import { openDemoMail } from '../lib/mailto';
export function VirtualTours() {
  const [activeId, setActiveId] = useState(tours[0].id);
  const [loadedIds, setLoadedIds] = useState<string[]>([]);
  const activeTour = tours.find(t => t.id === activeId) ?? tours[0];
  const isLoading = !loadedIds.includes(activeTour.id);
  return <main className="pt-32 pb-24 bg-zinc-950 min-h-screen" data-id="element-247" data-mp="1aod16ikq6sp4">
      <div className="max-w-7xl mx-auto px-6" data-id="element-248" data-mp="15ptdodqhh8un">
        <a href="#" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors mb-8" data-id="element-249" data-mp="15qla1qrwnalz">
          <ArrowLeft size={16} data-id="element-250" data-mp="303uf96df49yf" />
          Back to home
        </a>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10" data-id="element-251" data-mp="301zym496j405">
          <div className="max-w-2xl" data-id="element-252" data-mp="2v2wsshldktr4">
            <h1 className="text-4xl md:text-5xl font-display font-medium text-white mb-4 tracking-tight" data-id="element-253" data-mp="37sqyg6anibvi">
              Virtual Tours
            </h1>
            <p className="text-zinc-400 text-lg" data-id="element-254" data-mp="3bw6qsqfotq2e">
              Step inside our properties from anywhere. Pick a tour, then drag
              to look around, switch rooms, or go fullscreen and VR.
            </p>
          </div>
          <Button variant="secondary" onClick={openDemoMail} data-id="element-255" data-mp="3qjryyyrf6fh6">
            Book a Tour
          </Button>
        </div>

        <div className="grid lg:grid-cols-[260px_1fr] gap-6" data-id="element-256" data-mp="3vjcybaai4puf">
          {/* Tour selector */}
          <nav aria-label="Virtual tours" className="order-2 lg:order-1" data-id="element-257" data-mp="3gugrfgk6live">
            <ul className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0" data-id="element-258" data-mp="3lt1r9eviu0jb">
              {tours.map(tour => {
              const isActive = tour.id === activeId;
              return <li key={tour.id} className="shrink-0" data-id="element-259" data-mp="i4gkjx6fmcfy">
                    <button onClick={() => setActiveId(tour.id)} aria-current={isActive ? 'true' : undefined} className={`w-full text-left px-5 py-4 rounded-2xl whitespace-nowrap text-sm font-medium transition-colors duration-200 ${isActive ? 'bg-white text-zinc-950' : 'text-zinc-400 hover:text-white hover:bg-white/5 border border-white/5'}`} data-id="element-260" data-mp="i61dxjh0fpc8">
                      {tour.title}
                    </button>
                  </li>;
            })}
            </ul>
          </nav>

          {/* Viewer */}
          <section aria-label={activeTour.title} className="order-1 lg:order-2 relative rounded-3xl overflow-hidden glass-panel p-2" data-id="element-261" data-mp="3veb27eodzp2k">
            <div className="relative h-[480px] md:h-[640px] rounded-2xl overflow-hidden bg-zinc-900" data-id="element-262" data-mp="3mffx65x2wl0u">
              {isLoading && <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-zinc-400" data-id="element-263" data-mp="3hj8r8d4on9iw">
                  <Loader2 size={24} className="animate-spin" data-id="element-264" data-mp="21xoml3fcg70i" />
                  <span className="text-sm" data-id="element-265" data-mp="21w3tli8ogw4r">Loading tour…</span>
                </div>}
              <motion.iframe key={activeTour.id} src={activeTour.url} title={activeTour.title} className="absolute inset-0 w-full h-full border-0" allow="xr-spatial-tracking; gyroscope; accelerometer; fullscreen; vr" allowFullScreen initial={{
              opacity: 0
            }} animate={{
              opacity: isLoading ? 0 : 1
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} onLoad={() => setLoadedIds(ids => ids.includes(activeTour.id) ? ids : [...ids, activeTour.id])} data-id="element-266" data-mp="25xfj7nrjxhcy" />
            </div>
          </section>
        </div>
      </div>
    </main>;
}